var _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconLessOperator(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37.1,
    height: 53.6,
    viewBox: "0 0 37.1 53.6",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "svgGroup",
    strokeLinecap: "round",
    fillRule: "evenodd",
    fontSize: "9pt",
    stroke: "#000",
    strokeWidth: "0.25mm",
    fill: "#000",
    style: {
      stroke: "#000",
      strokeWidth: "0.25mm",
      fill: "#000"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M 32.4 52.4 L 2.9 32 A 11.444 11.444 0 0 1 1.952 31.278 Q 1.499 30.892 1.164 30.505 A 4.834 4.834 0 0 1 0.65 29.8 Q 0 28.7 0 27.4 L 0 26.2 Q 0 24.8 0.65 23.75 Q 1.3 22.7 2.9 21.6 L 32.4 1.2 L 33.65 0.45 Q 34.4 0 35.1 0 Q 35.9 0 36.5 0.5 A 1.595 1.595 0 0 1 37.021 1.34 Q 37.09 1.6 37.099 1.91 A 3.222 3.222 0 0 1 37.1 2 L 37.1 3.7 A 3.651 3.651 0 0 1 37.032 4.425 Q 36.94 4.879 36.724 5.236 A 2.211 2.211 0 0 1 36.65 5.35 Q 36.244 5.937 35.227 6.646 A 13.286 13.286 0 0 1 35 6.8 L 6.1 26.8 L 35 46.8 A 11.533 11.533 0 0 1 35.616 47.238 Q 36.327 47.783 36.65 48.25 A 2.429 2.429 0 0 1 37.014 49.092 Q 37.1 49.463 37.1 49.9 L 37.1 51.6 A 2.656 2.656 0 0 1 37.042 52.176 Q 36.913 52.756 36.5 53.1 Q 35.9 53.6 35.1 53.6 A 2.437 2.437 0 0 1 34.297 53.458 Q 33.998 53.354 33.691 53.175 A 4.193 4.193 0 0 1 33.65 53.15 L 32.4 52.4 Z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconLessOperator);
export default __webpack_public_path__ + "static/media/icon_less_operator.3c2559a5ee145b46d717347fc89fcbb8.svg";
export { ForwardRef as ReactComponent };